// ── MARKDOWN RENDERER (fp-nofodesk-9) — extracted from App.js ──
import { FONT_MONO } from "../theme";

// ── MarkdownText — renders bold, bullets, headings without a library ──
function MarkdownText({ text }) {
  const out = [];
  let listBuf = [];

  const flushList = () => {
    if (!listBuf.length) return;
    out.push(<ul key={out.length} style={{ margin: '4px 0 4px 0', paddingLeft: 18 }}>{listBuf.splice(0)}</ul>);
  };

  const inline = (s, k) => {
    const parts = s.split(/(\*\*(?:[^*]|\*(?!\*))+\*\*|\*[^*\n]+\*|`[^`\n]+`)/);
    return (
      <span key={k}>
        {parts.map((p, i) => {
          if (p.startsWith('**') && p.endsWith('**') && p.length > 4) return <strong key={i}>{p.slice(2, -2)}</strong>;
          if (p.startsWith('*') && p.endsWith('*') && p.length > 2) return <em key={i}>{p.slice(1, -1)}</em>;
          if (p.startsWith('`') && p.endsWith('`') && p.length > 2) return <code key={i} style={{ background: 'rgba(255,255,255,0.08)', borderRadius: 3, padding: '1px 5px', fontFamily: FONT_MONO, fontSize: '0.88em' }}>{p.slice(1, -1)}</code>;
          return p;
        })}
      </span>
    );
  };

  (text || '').split('\n').forEach((line, i) => {
    const bullet  = line.match(/^[ \t]*(?:[*-]|\d+[.)]) (.+)/);
    const heading = line.match(/^(#{1,4}) (.+)/);
    if (bullet) {
      listBuf.push(<li key={i} style={{ marginBottom: 2, lineHeight: 1.6 }}>{inline(bullet[1])}</li>);
    } else {
      flushList();
      if (heading) {
        out.push(<div key={i} style={{ fontWeight: 700, marginTop: heading[1].length <= 2 ? 8 : 4, marginBottom: 2 }}>{inline(heading[2])}</div>);
      } else if (!line.trim()) {
        out.push(<div key={i} style={{ height: 5 }} />);
      } else {
        out.push(<div key={i}>{inline(line)}</div>);
      }
    }
  });
  flushList();
  return <>{out}</>;
}
export default MarkdownText;
